// Single source of truth for API/base config and route/endpoint paths,
// mirroring global_100seconds_admin_frontend's common/constants.jsx.

export const BASE_URL: string =
  import.meta.env.VITE_API_BASE_URL ?? "https://quintara-website-api-685510445420.us-central1.run.app";

// Origin of the public website — used as the <base href> in the live-preview
// iframe so image URLs resolve against the real site.
export const WEBSITE_ORIGIN: string = import.meta.env.VITE_WEBSITE_ORIGIN ?? "https://quintaratech.com";

export const ROUTES = {
  LOGIN: "/login",
  PAGES: "/pages",
  PAGE_EDITOR: (slug: string) => `/pages/${slug}`,
  PAGE_HISTORY: (slug: string) => `/pages/${slug}/history`,
  TEAM: "/team",
} as const;

export const API_URLS = {
  LOGIN: "/auth/login",
  REFRESH: "/auth/refresh",
  LOGOUT: "/auth/logout",
  ME: "/auth/me",
  TEAM: "/team",
  TEAM_MEMBER: (id: string) => `/team/${id}`,
  TEAM_RESET_PW: (id: string) => `/team/${id}/reset-password`,
  CMS_PAGES: "/cms/admin/pages",
  CMS_PAGE: (slug: string) => `/cms/admin/pages/${slug}`,
  CMS_PUBLISH: (slug: string) => `/cms/admin/pages/${slug}/publish`,
  CMS_REVISIONS: (slug: string) => `/cms/admin/pages/${slug}/revisions`,
  CMS_REVISION: (slug: string, id: number) => `/cms/admin/pages/${slug}/revisions/${id}`,
  CMS_REVERT: (slug: string, id: number) => `/cms/admin/pages/${slug}/revert/${id}`,
} as const;
